import { useNavigate } from "react-router-dom";
import logo2 from "../../assets/marca.jpeg";
import "../login/login.css"
import { useEffect, useState } from "react";
import { dadosLogin } from "../../zustand/zuztand";

import moment from 'moment';
import api from "../../services/api.js";

import { auth } from "../../services/firebaseConfig";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";

function Login() {

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [nivel_usuario, setNivel_usuario] = useState("");
	const [controle_btn, setControle_btn] = useState(false);
	const navigate = useNavigate();
	const { changeUser, changeIfLogado, changeNivel } = dadosLogin();
	const [logado, setLogado] = useState(false);
	const [larguraTela, setLarguraTela] = useState(window.innerWidth);
	const ehMobile = larguraTela < 700;
	const [signInWithEmailAndPassword, user, loading, error] = useSignInWithEmailAndPassword(auth);
	const versao = "v1.0.2";

	// Handle window resize
	useEffect(() => {
		const handleResize = () => {
			setLarguraTela(window.innerWidth);
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	function ListarUsuariosLogin(e) {
		e.preventDefault();

		api.get("/verificaVersao")
			.then((resp) => {
				//console.log(resp.data[0].controle_versao)
				if (resp.data[0].controle_versao === versao) {
					setControle_btn(false);

					let email_usuario = email
					//console.log(email_usuario)
					api.get("/pegarDadosLogar", { params: { email_usuario } })
						.then((resp) => {
							//console.log(resp.data[0].versao)			
							//console.log(resp.data)
							if (resp.data.length >= 1) {
								signInWithEmailAndPassword(email, password).then(resp => {
									if (resp) {
										let logou = []
										logou = resp
										changeIfLogado(email);
										changeUser(email);
										navigate('/dashboard');
									} else {
										setLogado(!logado)
										function esperar() {
											setLogado(false);
										}
										setTimeout(esperar, 2000);
									}
								})
							} else {
								setLogado(!logado);
								function esperar() {
									setLogado(false);
								}
								setTimeout(esperar, 2000);
							}
							//setNivel_usuario(resp.data[0].nivel_user)
							localStorage.setItem('nivel_user', resp.data[0].nivel_user);
							//console.log(resp.data)				
							changeNivel(localStorage.getItem('nivel_user'));
						})
						.catch((err) => {
							setLogado(!logado);
							function esperar() {
								setLogado(false);
							} setTimeout(esperar, 2000);
						});
				} else {

					alert('Uma nova versão do sistema foi identificada e o mesmo precisará ser reiniciado, faça o login novamente para que as alterações tenham efeito!');
					//setLogado(!logado);		
					recarregarPagina()
					setControle_btn(true);
				}
			})
			.catch((err) => {
				//setLogado(!logado);
			});
	}

	function VerificaVersao() {
		api.get("/verificaVersao")
			.then((resp) => {
				//console.log(resp.data[0].controle_versao)
				if (resp.data[0].controle_versao === versao) {
					setControle_btn(false);
					alert('versão do sistema atualizada!');
				} else {
					alert('Nova versão do sistema identificada, faça o refresch da página para que as alterações tenham efeito!');
					//setLogado(!logado);					
					setControle_btn(true);
				}
			})
			.catch((err) => {
				//setLogado(!logado);
			});
	}

	function Logar(e) {
		e.preventDefault();
		if (nivel_usuario !== "usuarioPadrao") {
			signInWithEmailAndPassword(email, password).then(resp => {
				//console.log(resp)
				if (resp) {

					//localStorage.setItem('nivel_user', "")

					//let email_usuario = email
					//api.get("/pegarDadosLogar", { params: { email_usuario } })
					//.then((resp) => {
					//console.log(resp.data.nivel_user)
					//setNivel_user(resp.data.nivel_user)
					//	localStorage.setItem('nivel_user', resp.data.nivel_user);

					//console.log(resp.data[0].nivel_user)
					//setNivel_user(localStorage.getItem('nivel_user'))

					//console.log(resp.data.nivel_user)

					//	let nivel=resp.data.nivel_user;
					//console.log(nivel)
					//	setNivel_user(nivel)
					//	localStorage.setItem('nivel_user', nivel);

					//	})
					//.catch((err) => {

					//	setNivel_user("usuario_padrao")
					//});

					//ListarUsuariosLogin()
					let logou = []
					logou = resp
					//console.log(logou._tokenResponse.idToken)
					//console.log(logou.user.email)
					//dadosLogou.push(logou.user.email);				
					//localStorage.setItem('user_email', email)			
					//let userEmail = logou.user.email;
					//console.log(email)
					//changeNivel(nivel_usuario)
					//changeNivel(nivel_user)//salva nivel com o dado que veio do banco de dados
					changeIfLogado(email);
					changeUser(email);
					navigate('/dashboard');
				} else {
					//alert(" Usuário ou senha inválida");
					setLogado(!logado)

					function espera() {
						setLogado(false);
					}
					setTimeout(espera, 2000); //método executa a função após três segundos
				}
			})
		} else {
			alert('Erro de Login, tente novamente!')
		}
	}

	function recarregarPagina() {
		window.location.reload();
	};

	return <>
		{ehMobile ? <>
			<div className="login-container d-flex align-items-center justify-content-center ">
				<div className="card login-card ">
					<div className="card-body ">
						<div className="text-center mb-4">
							<div className="casa-ludica-logo">
								<img className="img-logo-login" src={logo2} alt="logo" />
							</div>
							<div className="row d-flex text-end">
								<small className="versao">{versao}</small>
							</div>
						</div>

						{/* Formulário */}
						<div className="mt-3">
							<div className="mb-3">
								<label htmlFor="email" className="form-label">Email/Usuário</label>
								<input
									type="text"
									className="form-control no-outline fc-login"
									id="email"
									name="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>

							<div className="mb-4">
								<label htmlFor="password" className="form-label">Senha</label>
								<input
									type="password"
									className="form-control no-outline fc-login"
									id="password"
									name="password"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
								/>
							</div>
							{
								logado ?
									<div className="alert alert-danger w-20" role="alert">
										Usuário ou senha inválidos!
									</div> : null
							}
							<div className="row d-flex m-0 btn-enter ">
								{
									controle_btn ?
										<>
											<div className="container-login100-form-btn">
												<button
													className="btn btn-enter"
													onClick={recarregarPagina}
												>Recarregar</button>
											</div>
										</>
										:
										<>
											<div className="container-login100-form-btn">
												<button
													className="btn btn-enter"
													onClick={ListarUsuariosLogin}
												>Entrar</button>
											</div>
										</>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
			:
			<>
				<div className=" h-100">
					<div className="limiter-login ">
						<div className="container-login100 fund-login tam-vert ">
							<div className="wrap-login100">
								<div className="login100-pic js-tilt ">
									<span className="fs-5 d-none d-sm-inline">
										<img src={logo2} className="img-logo" />
									</span>
									<div className="row d-flex text-end">
										<small className="versao">{versao}</small>
									</div>
								</div>
								<div className="login100-form validate-form ">
									<div className="wrap-input100 validate-input" >
										<span className="texto_input">Email/Usuário</span>
										<input className="input100" type="text" name="user" onChange={(e) => setEmail(e.target.value)} />
									</div>

									<div className="wrap-input100 validate-input" >
										<span className="texto_input">Senha</span>
										<input className="input100 input-user" type="password" name="pass" onChange={(e) => setPassword(e.target.value)} />
									</div>
									{
										logado ?
											<div className="alert alert-danger w-20" role="alert">
												Usuário ou senha inválidos!
											</div> : null
									}
									{
										controle_btn ?
											<>
												<div className="container-login100-form-btn">
													<button className="login100-form-btn btn-center" onClick={recarregarPagina}>Recarregar</button>
												</div>
											</>
											:
											<>
												<div className="container-login100-form-btn">
													<button className="login100-form-btn btn-center" onClick={ListarUsuariosLogin} >Entrar</button>
												</div>

											</>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		}
	</>
}

export default Login;